document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.swiper', {
    effect: "fade",
    fadeEffect: {
      crossFade: true
    },
    loop: true,
    slidesPerView: 1,
    autoHeight: true,
    speed: 1800,
    allowTouchMove: false,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
  });
});
